function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Select, Button, Form, Input, Upload, InputNumber, Flex, Space, Radio, Image, Alert, notification, Typography, Card, Switch } from 'antd';
import ImgCrop from 'antd-img-crop';
import { PlusCircleFill, EnvelopeAtFill, TelephoneFill, AwardFill } from "react-bootstrap-icons";
import axios from 'axios';
import Common from "../includes/Common";
import { Container, Row, Col } from "react-bootstrap";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var TextArea = Input.TextArea;
var VoteNow = function VoteNow(_ref) {
  var handler = _ref.handler,
    candidat = _ref.candidat;
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormLoading = _useState2[0],
    setIsFormLoading = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    pmList = _useState6[0],
    setPmList = _useState6[1];
  var _useState7 = useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    pg = _useState8[0],
    setPg = _useState8[1];
  var _useState9 = useState(0),
    _useState10 = _slicedToArray(_useState9, 2),
    ticketPrice = _useState10[0],
    setTicketPrice = _useState10[1];
  var _useState11 = useState(0),
    _useState12 = _slicedToArray(_useState11, 2),
    totalAmount = _useState12[0],
    setTotalAmount = _useState12[1];
  var _useState13 = useState(1),
    _useState14 = _slicedToArray(_useState13, 2),
    ticketQuantity = _useState14[0],
    setTicketQuantity = _useState14[1];
  var _useState15 = useState(1),
    _useState16 = _slicedToArray(_useState15, 2),
    receptionMode = _useState16[0],
    setReceptionMode = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    anonymous = _useState18[0],
    setAnonymous = _useState18[1];
  var handleSwitchChange = function handleSwitchChange(v) {
    setAnonymous(v == true ? 1 : 0);
  };
  var onFinish = function onFinish(values) {
    setIsFormLoading(true);
    setErrorMessage('');
    var formData = new FormData();
    formData.append('name', values.name);
    formData.append('mobile', values.mobile);
    formData.append("contest_milestone_candidate_id", candidat.id);
    formData.append('amount', totalAmount);
    formData.append('quantity', values.quantity);
    formData.append('payment_gateway_id', values.payment_gateway_id);
    formData.append('user_id', Common.currentUser == null || Common.currentUser == 'undefined' ? 0 : Common.currentUser.id);
    axios.post(Common.baseApiUrl + 'votenow', formData).then(function (response) {
      setIsFormLoading(false);
      if (response.data.code == 0) {
        window.location.href = response.data.payment_url;
      } else {
        setErrorMessage(response.data.message);
      }
    })["catch"](function (error) {
      window.scrollTo(0, 0);
      setIsFormLoading(false);
      setErrorMessage('Une erreur s\'est produite, ' + error.message);
    });
  };
  var handleQuantityChange = function handleQuantityChange(v) {
    setTicketQuantity(v);
    setTotalAmount(3000 * v);
  };
  useEffect(function () {
    setTotalAmount(3000);
    axios.all([axios.get(Common.baseApiUrl + 'getpgs')]).then(function (response) {
      if (response[0].data.status == 200) {
        setPmList([]);
        response[0].data.pgs.forEach(function (pg) {
          setPmList(function (prev) {
            return [].concat(_toConsumableArray(prev), [{
              value: pg.id,
              label: /*#__PURE__*/_jsxs(Flex, {
                gap: "small",
                justify: "center",
                align: "center",
                vertical: true,
                children: [/*#__PURE__*/_jsx(Image, {
                  preview: false,
                  width: "210px",
                  src: "drawables/" + pg.logo
                }), /*#__PURE__*/_jsx("b", {
                  children: pg.label
                })]
              })
            }]);
          });
        });
        if (response[0].data.pgs.length > 0) {
          form.setFieldsValue({
            payment_gateway_id: response[0].data.pgs[0].id
          });
          setPg(response[0].data.pgs.filter(function (g) {
            return g.pdcode == 'CC';
          })[0]);
        }
      }
    })["catch"](function (error) {
      notification.error({
        message: "Erreur",
        description: "Une erreur est survenue, verifiez votre connexion internet " + error.toString()
      });
    });
    if (Common.currentUser != 'undefined' && Common.currentUser != null) form.setFieldsValue({
      name: "".concat(Common.currentUser.firstname, " ").concat(Common.currentUser.lastname),
      email: Common.currentUser.email,
      mobile: Common.currentUser.mobile.slice(3)
    });
    form.setFieldsValue({
      quantity: 1
    });
  }, []);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(Form, {
      layout: "vertical",
      form: form,
      onFinish: onFinish,
      autoComplete: "off",
      children: [/*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Card, {
          hoverable: false,
          style: {
            width: "100%"
          },
          styles: {
            body: {
              padding: 0,
              overflow: 'hidden'
            }
          },
          children: /*#__PURE__*/_jsxs(Flex, {
            justify: "space-between",
            children: [/*#__PURE__*/_jsx("img", {
              src: candidat.cover_url,
              style: {
                display: "block",
                width: "100px",
                height: "100px",
                borderRadius: "100px"
              }
            }), /*#__PURE__*/_jsx(Flex, {
              vertical: true,
              align: "flex-end",
              justify: "space-between",
              style: {
                padding: 32
              },
              children: /*#__PURE__*/_jsxs(Typography.Title, {
                level: 5,
                children: ["Votez pour ", candidat.name]
              })
            })]
          })
        })
      }), errorMessage.length > 0 && /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Alert, {
          banner: true,
          closable: true,
          style: {
            marging: '5px 0px',
            fontSize: '14px'
          },
          message: errorMessage,
          type: "error",
          showIcon: true
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        label: "Je pr\xE9f\xE8re un vote anonyme",
        children: /*#__PURE__*/_jsx(Switch, {
          onChange: handleSwitchChange
        })
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: "name",
        label: "Entrez votre nom",
        rules: [{
          required: anonymous == 0,
          message: 'Veuillez entrer votre nom'
        }],
        children: /*#__PURE__*/_jsx(Input, {
          disabled: anonymous == 1,
          placeholder: "Entrez votre nom ici"
        })
      }), /*#__PURE__*/_jsx(Row, {
        children: /*#__PURE__*/_jsx(Col, {
          lg: 12,
          md: 12,
          sm: 12,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "mobile",
            label: "T\xE9l\xE9phone",
            rules: [{
              required: anonymous == 0,
              message: "Ce champ est obligatoire"
            }],
            children: /*#__PURE__*/_jsx(InputNumber, {
              disabled: anonymous == 1,
              addonBefore: /*#__PURE__*/_jsx(TelephoneFill, {}),
              placeholder: "Numero de T\xE9l\xE9phone",
              style: {
                width: "100%"
              }
            })
          })
        })
      }), /*#__PURE__*/_jsxs(Row, {
        children: [/*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            label: "Nombre de votes",
            name: "quantity",
            rules: [{
              required: true,
              message: "Ce champ est obligatoire"
            }],
            children: /*#__PURE__*/_jsx(InputNumber, {
              addonBefore: /*#__PURE__*/_jsx(AwardFill, {}),
              size: "large",
              onChange: handleQuantityChange,
              style: {
                width: "140px"
              }
            })
          })
        }), /*#__PURE__*/_jsx(Col, {
          lg: 6,
          md: 6,
          sm: 6,
          children: /*#__PURE__*/_jsx(Form.Item, {
            name: "payment_gateway_id",
            rules: [{
              required: true,
              message: "Ce champ est obligatoire"
            }],
            children: /*#__PURE__*/_jsx(Radio.Group, {
              options: pmList
            })
          })
        })]
      }), /*#__PURE__*/_jsx(Form.Item, {
        children: /*#__PURE__*/_jsx(Button, {
          disabled: pmList.length == 0,
          loading: isFormLoading,
          type: "primary",
          size: "large",
          htmlType: "submit",
          children: /*#__PURE__*/_jsxs("b", {
            children: ["PAYER ", totalAmount.toLocaleString('Fr'), " GNF"]
          })
        })
      })]
    })
  });
};
export default VoteNow;